// Per-device memory of the user's choice about affiliate-linked product
// recommendations.
//
// Whether the disclosure applies at all is decided by the backend /config flag
// `show_affiliate_disclosure` (surfaced via UserContext). This module only
// records the user's accept/decline locally, so once they have opted in the
// gate isn't shown again — and no extra API call is needed to remember it.

const STORAGE_KEY = 'kivo_affiliate_recs';

export type AffiliateChoice = 'on' | 'off' | null;

export function readAffiliateChoice(): AffiliateChoice {
  if (typeof localStorage === 'undefined') return null;
  try {
    const v = localStorage.getItem(STORAGE_KEY);
    return v === 'on' || v === 'off' ? v : null;
  } catch {
    return null;
  }
}

export function writeAffiliateChoice(value: 'on' | 'off'): void {
  if (typeof localStorage === 'undefined') return;
  try {
    localStorage.setItem(STORAGE_KEY, value);
  } catch {
    /* private mode / quota — the in-memory state still drives this session */
  }
}

/** True only when the user has explicitly opted in on this device. */
export function affiliateRecsEnabled(): boolean {
  return readAffiliateChoice() === 'on';
}
